/**
 * useR4RAccess — portails R4R autorisés pour le collaborateur connecté
 * (rectorium_team_members.r4r_portal_roles). Registre INDÉPENDANT du rôle
 * Master (plan §7) : vide par défaut, y compris pour un Super Master.
 * Même pattern de cache que useMasterAccessScope.js / useMasterPortalRole.js.
 */
import { createMasterTeamFieldHook } from './masterTeamFieldCache';

const [useR4RAccess, invalidateR4RAccessCache] = createMasterTeamFieldHook({
  column: 'r4r_portal_roles',
  resultKey: 'portalIds',
  mapValue: (raw) => (Array.isArray(raw) ? raw : []),
  defaultValue: [],
});

export default useR4RAccess;
/** Invalide le cache (après un octroi/retrait d'accès R4R approuvé, ou au logout). */
export { invalidateR4RAccessCache };
